import {createSlice} from "@reduxjs/toolkit";
import {createReview} from "services/review/review";

const initialState = {
    review : {
        data : [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const addReviewSlice = createSlice({
    name: 'addReview',
    initialState,
    extraReducers:{
        [createReview.pending]:(state) =>{
            state.review.isLoading = true
            state.review.errorMessage = '';
        },
        [createReview.fulfilled]: (state, {payload}) =>{
            state.review.isSuccess = true;
            state.review.isLoading = false;
            state.review.data = payload;
        },
        [createReview.rejected]: (state, {payload}) =>{
            state.review.isSuccess = false;
            state.review.isLoading = false;
            state.review.errorMessage = payload;
        }
    }
})

export default addReviewSlice.reducer;